var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row gx-2"},[_c('div',{staticClass:"col"},[_c('apex-chart',{key:_vm.chartKey,attrs:{"width":"100%","type":"bar","options":_vm.graphOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }